import React, { FunctionComponent } from 'react';
import MultiSelectFilterField from './MultiSelectFilterField';
import DatePickerFilterField from './DatePickerFilterField';
import TextFilterField from './TextFilterField';
import { FormFieldProps } from '../../FormDisplay/FormFieldDisplay/FormFieldDisplay';

const FilterFieldDisplay: FunctionComponent<FormFieldProps> = (props) => {
    const { formField, value, handleInputChange, error, formData } = props;

    let FieldComponent: FunctionComponent<FormFieldProps>;

    switch (formField.typeId) {
        case 'date':
            FieldComponent = DatePickerFilterField;
            break;
        case 'choices':
            FieldComponent = MultiSelectFilterField;
            break;
        case 'shorttext':
        default:
            FieldComponent = TextFilterField;
    }

    if (formField.typeId !== 'system') {
        return (
            <FieldComponent
                formField={formField}
                value={value}
                handleInputChange={handleInputChange}
                error={error}
                formData={formData}
            />
        );
    }

    return null;
};

export default FilterFieldDisplay;
